<script lang="ts">
import { defineComponent } from 'vue'
import CButton from '@/components/common/CButton.vue'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'PopWarning',
  components: { CButton },
  data() {
    return {
      outLink: 'https://medium.com/pundiai/pundi-aifx-omnilayer-sunsetting-migration-to-ethereum-begins-584f6ea70b27'
    }
  },
  methods: {
    goOut() {
      window.open(this.outLink, '_blank', 'noreferrer noopener')
    },
    close() {
      this.$store.commit('setWarningShow', false)
    }
  },
  computed: {
    ...mapState(['warningShow'])
  }
})
</script>

<template>
  <div class="warning" v-show="warningShow">
    <div class="warning-mask" @click="close"></div>
    <div class="warning-content">
      <div class="warning-logo"><i class="common-icon-logo-warning"></i></div>
      <div class="warning-text">
        <p>
          <span class="warning-text-strong">Pundi AIFX OmniLayer</span> is being sunset as part of our planned migration
          to <span class="warning-text-strong">Ethereum</span>.
        </p>
        <p>
          To ensure long term security, liquidity, and ecosystem growth, core activity is transitioning to Ethereum.
          Pundi AIFX OmniLayer will remain operational during the migration period, and no immediate action is required
          for most users.
        </p>
        <p>
          For full details on the migration timeline and next steps, please refer to the official announcement.
        </p>
      </div>
      <div class="warning-btns">
        <div class="warning-btns-item">
          <CButton type="lineWhite" :height="42" min-width="202px" border-radius="4px" @click="close"
            ><div class="font-bold">I Understand</div></CButton
          >
        </div>
        <div class="warning-btns-item">
          <CButton
            type="colorful"
            :height="42"
            :clickRipple="false"
            min-width="202px"
            border-radius="4px"
            @click="goOut"
          >
            <div class="font-bold">Learn More</div>
          </CButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.warning {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.warning-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.warning-content {
  position: relative;
  width: 484px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: #1b1a28;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 24px 32px 32px;
}
.warning-logo {
  width: 128px;
}
.warning-text {
  margin-top: 16px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 24px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
}
.warning-text-strong {
  color: rgba(255, 255, 255, 1);
}
.warning-link {
  color: rgba(255, 255, 255, 0.6);
  font-family: inherit;
  text-decoration: underline;
  transition: color 0.3s;
  &:hover {
    color: rgba(255, 255, 255, 1);
  }
}
.warning-btns {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.warning-btns-item {
}
</style>
